import type { Breadcrumb, Event } from "@sentry/core";

const PII_FIELD_NAMES = new Set([
  "ssn",
  "socialsecuritynumber",
  "social_security_number",
  "dateofbirth",
  "dob",
  "date_of_birth",
  "birthdate",
  "annualincome",
]);
const SSN_PATTERN = /\b\d{3}-?\d{2}-?\d{4}\b/g;
const REDACTED = "[REDACTED]";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function scrubPiiFromObject(data: Record<string, unknown>): void {
  for (const key of Object.keys(data)) {
    const value = data[key];
    if (PII_FIELD_NAMES.has(key.toLowerCase())) {
      data[key] = REDACTED;
    } else if (typeof value === "string") {
      data[key] = value.replace(SSN_PATTERN, REDACTED);
    } else if (isRecord(value)) {
      scrubPiiFromObject(value);
    }
  }
}

export function scrubPiiFromEvent(event: Event): void {
  // Scrub request body
  if (event.request?.data && isRecord(event.request.data)) {
    scrubPiiFromObject(event.request.data);
  } else if (event.request?.data && typeof event.request.data === "string") {
    event.request.data = event.request.data.replace(SSN_PATTERN, REDACTED);
  }

  // Scrub exception values
  if (event.exception?.values) {
    for (const ex of event.exception.values) {
      if (ex.value) {
        ex.value = ex.value.replace(SSN_PATTERN, REDACTED);
      }
    }
  }

  // Scrub breadcrumb messages
  if (event.breadcrumbs) {
    for (const crumb of event.breadcrumbs) {
      if (typeof crumb.message === "string") {
        crumb.message = crumb.message.replace(SSN_PATTERN, REDACTED);
      }
      if (crumb.data && isRecord(crumb.data)) {
        scrubPiiFromObject(crumb.data);
      }
    }
  }
}

export function scrubCreditBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb | null {
  if (breadcrumb.type === "http" && breadcrumb.data?.url) {
    const url = String(breadcrumb.data.url);
    if (url.includes("/credit/") || url.includes("/api/credit-submission")) {
      breadcrumb.data.requestBody = undefined;
      breadcrumb.data.responseBody = undefined;
      breadcrumb.data.request_body_size = undefined;
    }
  }
  return breadcrumb;
}
